import formReducer from 'abyss-form/lib/reducer';
export default formReducer([
  'login',
  'verify',
  'profile',
  'search',
  'publish',
  'newChatUsers',
  'chat'
]);



// WEBPACK FOOTER //
// ./src/state/forms/reducer.js